import * as React from "react";
const SvgUndoIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<path d="M4.96447 11.5355C5.86928 12.4404 7.11928 13 8.5 13C11.2614 13 13.5 10.7614 13.5 8C13.5 5.23858 11.2614 3 8.5 3C7.11928 3 5.86928 3.55964 4.96447 4.46447C4.50391 4.92503 3.5 6.05556 3.5 6.05556M3.5 3.83078V6.053H5.72222" stroke="#606060" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></svg>;
export default SvgUndoIcon;